import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsAgmMaterialsInfoContentPageHeaderCls: string;
			investorsAgmMaterialsInfoLinksItemWrapperCls: string;
			investorsAgmMaterialsInfoLinksSpacerCls: string;
		}
	},

	slug: string
}

class Info extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Agm Materials Info Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoContentPageHeaderCls || '', 'investors_agm_materials_info', { animCls: 'animate__flipInX', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksItemWrapperCls + '1', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksItemWrapperCls + '2', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksItemWrapperCls + '3', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksItemWrapperCls + '4', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksItemWrapperCls + '5', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksSpacerCls + '1', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksSpacerCls + '2', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksSpacerCls + '3', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAgmMaterialsInfoLinksSpacerCls + '4', 'investors_agm_materials_info', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Info;